/* eslint-disable @typescript-eslint/naming-convention */
import {Type} from 'class-transformer';
import 'reflect-metadata';
import {
  AppColorList,
  AppTypographyList,
  AppWidthList,
  BlockElementSettingsDividerList, BlockElementSettingsTextDecoration,
  BlockElementSettingsVerticalDividerList,
  BlockElementType,
  BlockIconVerticalAlignmentList,
  BlockSettingsAlignmentList
} from '../enums';
import {BlockAction} from './blockAction';
import {BlockElementIcon} from './blockElementIcon';
import {BlockElement, BlockElementSettings} from './blockElement';
import {Entity} from '../../core/main.entity';
import {BlockElementGallery} from './blockElementGallery';
import {BlockElementGroup} from './blockElementGroup';
import {BlockElementWorker} from './blockElementWorker';
import {BlockElementArticle} from './blockElementAritlce';
import {BlockElementButton} from './blockElementButton';
import {BlockElementImage} from './blockElementImage';
import {Blocks} from './block.entity';

export class BlockElementLabel extends Entity {
  type: BlockElementType = 'label';
  text?: string = null;

  @Type(() => BlockElementLabelSettings)
  settings?: BlockElementLabelSettings = null;
}

export class BlockElementContainer extends BlockElement {
  type: BlockElementType = 'basic';
  text?: string = null;

  @Type(() => BlockElementContainerSettings)
  settings?: BlockElementContainerSettings = new BlockElementContainerSettings();

  @Type(() => BlockElementIcon)
  icon?: BlockElementIcon = null;

  @Type(() => BlockAction)
  action?: BlockAction = null;

  @Type(() => Entity, {
    discriminator: {
      property: 'type',
      subTypes: [
        {value: BlockElementContainer, name: 'basic'},
        {value: BlockElementContainer, name: 'empty'},
        {value: BlockElementContainer, name: 'card'},
        {value: BlockElementLabel, name: 'label'},
        {value: BlockElementGallery, name: 'gallery'},
        {value: BlockElementGroup, name: 'group'},
        {value: BlockElementWorker, name: 'worker'},
        {value: BlockElementArticle, name: 'article'},
        {value: BlockElementButton, name: 'button'},
        {value: BlockElementIcon, name: 'icon'},
        {value: BlockElementImage, name: 'image'}
      ],
    },
    keepDiscriminatorProperty: true
  })
  items?: Blocks[] = [];
}

export class BlockElementContainerSettings extends BlockElementSettings {
  typography?: AppTypographyList = 'text';
  width?: AppWidthList = 'full';
  color?: AppColorList = 'text';
  alignment?: BlockSettingsAlignmentList = 'left';
  verticalAlignment?: BlockIconVerticalAlignmentList = 'top';
  divider?: BlockElementSettingsDividerList = '5';
  verticalDivider?: BlockElementSettingsVerticalDividerList = '0';
  background?: AppColorList = null;
  cropLines?: number = null;
  decoration?: BlockElementSettingsTextDecoration = 'none';
}

export class BlockElementLabelSettings extends BlockElementSettings {
  typography?: AppTypographyList = 'navigation-small';
  color?: AppColorList = 'white';
  alignment?: BlockSettingsAlignmentList = 'left';
  verticalAlignment?: BlockIconVerticalAlignmentList = 'top';
  background?: AppColorList = 'primary';
  cropLines?: number = null;
}
